import React, { useState, useEffect, useContext } from 'react';
import { get } from 'lodash';
import WebSocketContext from 'data/WebsocketContext';
import NotificationButton from 'components/NotificationButton';
import generateNonce from 'utils/generateNonce';

const WsNotificationButton = () => {
  const client = useContext(WebSocketContext);
  const [nonce, setNonce] = useState('initial-key');

  useEffect(() => {
    if (client) {
      const connection = client.socket();
      // remmove all handlers to avoid multiple registration
      connection.off('ReceiveMessage');
      // "on" setup with multiple handlers on the same event, will call all handlers sequencially
      connection.on('ReceiveMessage', message => {
        console.log(message);
        if (get(message, 'type') === 'NotificaitonUpdate') {
          setNonce(generateNonce());
        }
      });
    }
  }, [client]);

  return (
    <div key={nonce}>
      <NotificationButton variant="standard"/>
    </div>
  );
};

export default React.memo(WsNotificationButton);
